import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LockIcon, MailIcon, AlertCircleIcon, UserIcon } from 'lucide-react';
import Logo from '../components/Logo';
import Button from '../components/Button';
const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const {
    login
  } = useAuth();
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
      const success = await login(email, password);
      if (!success) {
        setError('Invalid email or password');
      }
    } catch (err) {
      setError('An error occurred during login');
    } finally {
      setIsLoading(false);
    }
  };
  // Function to auto-fill credentials
  const fillCredentials = (email: string, password: string) => {
    setEmail(email);
    setPassword(password);
  };
  return <div className="min-h-screen bg-neutral-50 flex flex-col justify-center items-center p-4" data-id="element-1966">
      <div className="w-full max-w-md" data-id="element-1967">
        <div className="text-center mb-8" data-id="element-1968">
          <div className="flex justify-center mb-4" data-id="element-1969">
            <Logo size="large" data-id="element-1970" />
          </div>
          <h1 className="text-2xl font-bold text-secondary" data-id="element-1971">
            Where Growth Meets Impact.
          </h1>
          <p className="text-neutral-400 mt-2" data-id="element-1972">
            We are closing the MSME financing gap by connecting Malaysia's most ambitious businesses with investors who want to make a real-world impact.
          </p>
        </div>
        <div className="bg-white rounded-lg shadow-card p-8" data-id="element-1973">
          <h2 className="text-xl font-bold mb-6" data-id="element-1974">Sign In</h2>
          {error && <div className="mb-6 p-3 bg-error bg-opacity-10 border border-error border-opacity-20 rounded-lg flex items-start" data-id="element-1975">
              <AlertCircleIcon className="w-5 h-5 text-error mr-2 flex-shrink-0 mt-0.5" data-id="element-1976" />
              <span className="text-sm text-error" data-id="element-1977">{error}</span>
            </div>}
          <form onSubmit={handleSubmit} data-id="element-1978">
            <div className="mb-4" data-id="element-1979">
              <label htmlFor="email" className="block text-sm font-medium mb-2" data-id="element-1980">
                Email Address
              </label>
              <div className="relative" data-id="element-1981">
                <input id="email" type="email" className="w-full border border-neutral-200 rounded-lg py-2 pl-10 pr-3 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary" value={email} onChange={e => setEmail(e.target.value)} placeholder="Enter your email" required data-id="element-1982" />
                <MailIcon className="w-5 h-5 text-neutral-400 absolute left-3 top-2.5" data-id="element-1983" />
              </div>
            </div>
            <div className="mb-6" data-id="element-1984">
              <label htmlFor="password" className="block text-sm font-medium mb-2" data-id="element-1985">
                Password
              </label>
              <div className="relative" data-id="element-1986">
                <input id="password" type="password" className="w-full border border-neutral-200 rounded-lg py-2 pl-10 pr-3 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary" value={password} onChange={e => setPassword(e.target.value)} placeholder="Enter your password" required data-id="element-1987" />
                <LockIcon className="w-5 h-5 text-neutral-400 absolute left-3 top-2.5" data-id="element-1988" />
              </div>
            </div>
            <Button type="submit" variant="primary" fullWidth disabled={isLoading} data-id="element-1989">
              {isLoading ? 'Signing in...' : 'Sign In'}
            </Button>
          </form>
          <div className="mt-6 pt-6 border-t border-neutral-100" data-id="element-1990">
            <h3 className="text-sm font-medium mb-4" data-id="element-1991">Demo Credentials</h3>
            <div className="grid grid-cols-2 gap-3" data-id="element-1992">
              <button type="button" onClick={() => fillCredentials('msme@example.com', 'Fc6wiINFrx')} className="text-left text-xs p-3 bg-neutral-50 rounded hover:bg-primary hover:bg-opacity-5 border border-transparent hover:border-primary transition-colors duration-200" data-id="element-1993">
                <div className="flex items-center" data-id="element-1994">
                  <UserIcon className="w-3 h-3 mr-1 text-primary" data-id="element-1995" />
                  <span className="font-medium text-primary" data-id="element-1996">MSME Owner</span>
                </div>
                <div data-id="element-1997">msme@example.com</div>
                <div className="text-neutral-400" data-id="element-1998">Fc6wiINFrx</div>
              </button>
              <button type="button" onClick={() => fillCredentials('investor@example.com', 'Fc6wiINFrx')} className="text-left text-xs p-3 bg-neutral-50 rounded hover:bg-primary hover:bg-opacity-5 border border-transparent hover:border-primary transition-colors duration-200" data-id="element-1999">
                <div className="flex items-center" data-id="element-2000">
                  <UserIcon className="w-3 h-3 mr-1 text-primary" data-id="element-2001" />
                  <span className="font-medium text-primary" data-id="element-2002">Investor</span>
                </div>
                <div data-id="element-2003">investor@example.com</div>
                <div className="text-neutral-400" data-id="element-2004">Fc6wiINFrx</div>
              </button>
              <button type="button" onClick={() => fillCredentials('shariah@example.com', 'Fc6wiINFrx')} className="text-left text-xs p-3 bg-neutral-50 rounded hover:bg-primary hover:bg-opacity-5 border border-transparent hover:border-primary transition-colors duration-200" data-id="element-2005">
                <div className="flex items-center" data-id="element-2006">
                  <UserIcon className="w-3 h-3 mr-1 text-primary" data-id="element-2007" />
                  <span className="font-medium text-primary" data-id="element-2008">
                    Shariah Advisor
                  </span>
                </div>
                <div data-id="element-2009">shariah@example.com</div>
                <div className="text-neutral-400" data-id="element-2010">Fc6wiINFrx</div>
              </button>
              <button type="button" onClick={() => fillCredentials('trustee@example.com', 'Fc6wiINFrx')} className="text-left text-xs p-3 bg-neutral-50 rounded hover:bg-primary hover:bg-opacity-5 border border-transparent hover:border-primary transition-colors duration-200" data-id="element-2011">
                <div className="flex items-center" data-id="element-2012">
                  <UserIcon className="w-3 h-3 mr-1 text-primary" data-id="element-2013" />
                  <span className="font-medium text-primary" data-id="element-2014">Trustee</span>
                </div>
                <div data-id="element-2015">trustee@example.com</div>
                <div className="text-neutral-400" data-id="element-2016">Fc6wiINFrx</div>
              </button>
              <button type="button" onClick={() => fillCredentials('advisor@example.com', 'Fc6wiINFrx')} className="text-left text-xs p-3 bg-neutral-50 rounded hover:bg-primary hover:bg-opacity-5 border border-transparent hover:border-primary transition-colors duration-200" data-id="element-2017">
                <div className="flex items-center" data-id="element-2018">
                  <UserIcon className="w-3 h-3 mr-1 text-primary" data-id="element-2019" />
                  <span className="font-medium text-primary" data-id="element-2020">
                    Digital Advisor
                  </span>
                </div>
                <div data-id="element-2021">advisor@example.com</div>
                <div className="text-neutral-400" data-id="element-2022">Fc6wiINFrx</div>
              </button>
              <button type="button" onClick={() => fillCredentials('rating@example.com', 'Fc6wiINFrx')} className="text-left text-xs p-3 bg-neutral-50 rounded hover:bg-primary hover:bg-opacity-5 border border-transparent hover:border-primary transition-colors duration-200" data-id="element-2023">
                <div className="flex items-center" data-id="element-2024">
                  <UserIcon className="w-3 h-3 mr-1 text-primary" data-id="element-2025" />
                  <span className="font-medium text-primary" data-id="element-2026">
                    Rating Agency
                  </span>
                </div>
                <div data-id="element-2027">rating@example.com</div>
                <div className="text-neutral-400" data-id="element-2028">Fc6wiINFrx</div>
              </button>
            </div>
          </div>
        </div>
        <div className="mt-6 text-center" data-id="element-2029">
          <span className="font-medium text-primary" data-id="element-2030">
             Copyright © 2025 SukukNa | RollingPay Sdn. Berhad
          </span>
        </div>
      </div>
    </div>;
};
export default LoginPage;